import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-premium py-3' : 'bg-transparent py-5'}`} data-id="element-509">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-510">
        <div className="flex justify-between items-center" data-id="element-511">
          <div className="flex items-center" data-id="element-512">
            <div className="flex-shrink-0" data-id="element-513">
              <a href="/" className="flex items-center transition-transform hover:scale-105" aria-label="Retour à l'accueil" data-id="element-514">
                <div className="bg-white p-2 rounded-md shadow-sm mr-3" data-id="element-515">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6hFeyx2cfKZZEniYCGUcu3/RISKEYS-8-150x150.png" alt="Riskeys Logo" className="h-10 w-auto" data-id="element-516" />
                </div>
                <span className={`font-bold text-xl ${isScrolled ? 'text-riskeys-dark' : 'text-white'}`} data-id="element-517">
                  RISKEYS
                </span>
              </a>
            </div>
          </div>
          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-518">
            <a href="#qui-sommes-nous" className={`px-3 py-2 text-sm font-medium transition-all duration-300 ${isScrolled ? 'text-riskeys-dark hover:text-riskeys-accent-default' : 'text-white hover:text-riskeys-accent-light'}`} data-id="element-519">
              Qui sommes-nous
            </a>
            <a href="#domaines-interventions" className={`px-3 py-2 text-sm font-medium transition-all duration-300 ${isScrolled ? 'text-riskeys-dark hover:text-riskeys-accent-default' : 'text-white hover:text-riskeys-accent-light'}`} data-id="element-520">
              Nos expertises
            </a>
            <a href="#success-stories" className={`px-3 py-2 text-sm font-medium transition-all duration-300 ${isScrolled ? 'text-riskeys-dark hover:text-riskeys-accent-default' : 'text-white hover:text-riskeys-accent-light'}`} data-id="element-521">
              Références
            </a>
            <a href="#faq" className={`px-3 py-2 text-sm font-medium transition-all duration-300 ${isScrolled ? 'text-riskeys-dark hover:text-riskeys-accent-default' : 'text-white hover:text-riskeys-accent-light'}`} data-id="element-522">
              FAQ
            </a>
            <a href="#contact" className={`px-5 py-2.5 rounded-md text-sm font-medium transition-all duration-300 ${isScrolled ? 'bg-riskeys-blue-default text-white hover:bg-riskeys-blue-dark shadow-md hover:shadow-lg' : 'bg-riskeys-accent-default text-white hover:bg-riskeys-accent-dark shadow-md hover:shadow-lg'}`} data-id="element-523">
              Contact
            </a>
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-524">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className={`inline-flex items-center justify-center p-2 rounded-md ${isScrolled ? 'text-riskeys-dark hover:text-riskeys-blue-default hover:bg-riskeys-gray-light' : 'text-white hover:text-riskeys-accent-light hover:bg-white/10'} focus:outline-none transition-colors`} aria-label="Menu principal" data-id="element-525">
              {isMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-526" /> : <MenuIcon className="block h-6 w-6" data-id="element-527" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-528">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 backdrop-blur-md shadow-premium" data-id="element-529">
            <a href="#qui-sommes-nous" className="block px-4 py-3 rounded-lg text-base font-medium text-riskeys-dark hover:text-riskeys-accent-default hover:bg-riskeys-gray-light transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-530">
              Qui sommes-nous
            </a>
            <a href="#domaines-interventions" className="block px-4 py-3 rounded-lg text-base font-medium text-riskeys-dark hover:text-riskeys-accent-default hover:bg-riskeys-gray-light transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-531">
              Nos expertises
            </a>
            <a href="#success-stories" className="block px-4 py-3 rounded-lg text-base font-medium text-riskeys-dark hover:text-riskeys-accent-default hover:bg-riskeys-gray-light transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-532">
              Références
            </a>
            <a href="#faq" className="block px-4 py-3 rounded-lg text-base font-medium text-riskeys-dark hover:text-riskeys-accent-default hover:bg-riskeys-gray-light transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-533">
              FAQ
            </a>
            <a href="#contact" className="block px-4 py-3 rounded-lg text-base font-medium bg-riskeys-accent-default text-white hover:bg-riskeys-accent-dark transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-534">
              Contact
            </a>
          </div>
        </div>}
    </nav>;
}